// extracted by mini-css-extract-plugin
module.exports = {"map":"ArticleMap_map__9vjKX","unGrouped":"ArticleMap_unGrouped__NiZky","mainMap":"ArticleMap_mainMap__Kqecq"};